document.addEventListener('DOMContentLoaded', () => {
  const textarea = document.querySelector('[data-quote-form] textarea[name="contact[body]"]');
  if (!textarea) return;

  textarea.setAttribute('maxlength', '150');
  textarea.setAttribute('placeholder', '');

  let counter = textarea.parentElement?.querySelector('[data-cart-message-counter]');
  if (!counter) {
    counter = document.createElement('small');
    counter.setAttribute('data-cart-message-counter', '');
    counter.className = 'cart-message-counter';
    textarea.insertAdjacentElement('afterend', counter);
  }

  const updateCounter = () => {
    if (textarea.value.length > 150) textarea.value = textarea.value.slice(0, 150);
    counter.textContent = `${textarea.value.length}/150 caractere`;
  };

  textarea.addEventListener('input', updateCounter);
  updateCounter();
});
